import qs from 'query-string'
import useSWR from 'swr'

import { IPlan } from '../types'
import createRestClient from './createRestClient'
import useOrganization from './useOrganization'

export default function usePublicPlans() {
  const organization = useOrganization()

  const { data, error } = useSWR(
    () => {
      if (organization === undefined) {
        // See https://github.com/vercel/swr#dependent-fetching
        throw new Error('organization was not loaded')
      }

      return qs.stringifyUrl(
        {
          url: 'plans',
          query: {
            customer: organization.stripeCustomerId,
          },
        },
        { skipNull: true },
      )
    },
    async (url) => {
      const { plans } = await createRestClient().get<{
        plans: Array<IPlan>
      }>(url)
      return plans
    },
  )

  if (error) {
    throw error
  }

  return data
}
